
const segmenter = new Intl.Segmenter(); // to get emojis 😝
// TODO only exported for testing ... figure out a neater solution
export function getBrandInitials(name: string): string {
  return name.split(' ', 4).map(w => segmenter.segment(w)[Symbol.iterator]().next().value?.segment || '❗').join('');
}
